import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { MaterialShoreHardnessFragmentFragmentDoc } from './materialShoreHardnessFragment';
import { ToleranceFragmentFragmentDoc } from './toleranceFragment';
export type EnquiryMaterialFragmentFragment = { __typename?: 'Material', id: string, name: string, options?: object | null, partMarkings?: object | null, shoreHardnesses: Array<{ __typename?: 'ShoreHardness', custom: boolean, default: boolean, id: number, name: string }>, tolerancesNew: Array<{ __typename?: 'Tolerance', default: boolean, i18nKey?: string | null, id: number, name: string, quantityEnabled: boolean, value: string }> };

export const EnquiryMaterialFragmentFragmentDoc = gql`
    fragment enquiryMaterialFragment on Material {
  id
  name
  options
  shoreHardnesses {
    ...materialShoreHardnessFragment
  }
  tolerancesNew {
    ...toleranceFragment
  }
  partMarkings
}
    ${MaterialShoreHardnessFragmentFragmentDoc}
${ToleranceFragmentFragmentDoc}`;